import { IonRow, IonCol, IonGrid } from "@ionic/react";
import React from "react";
import { OriginRadius, Origin } from "../../../utils/constants";
import { NewInput } from "../../../components/shared/NewUIComponents/OriginInput";
import { RadiusRange } from "../../../components/shared/NewUIComponents/RadiusRange";
import { useTranslation } from "react-i18next";
import { PickUpTimeComponent } from "../../../components/shared/pickupTimeComponent";

const PickupData = (props: any) => {
  const {
    isCurrentLocationOff,
    originError,
    origin,
    originRadius,
    originCountry,
    originPostalCode,
    pickUpdateError,
    isDestination,
    defaultValue,
    useHandler,
    setErrorValue,
    updateLocalCurrentTime,
    pickUpLocalTime,
    isCapacitor,
    pickUpStartDate,
    pickUpEndDate,
    rangeOriginDisable,
    handleError,
    allowAnywhere = false,
  } = props;
  const upDateLocalTime = (time: string) => {
    if (props.showDate) {
      updateLocalCurrentTime('pickUpStartDate', time);
    }
  };
  const dateChanged = (e: any) => {
    const event = {
      target: {
        name:
          e.target.name === 'fromDate' ? 'pickUpStartDate' : 'pickUpEndDate',
        value: e.target.value,
      },
    };
    props.handleChange(event);
  };
  const { t } = useTranslation();
  return (
    <IonGrid className="pickup-data" data-testid="pickupdata">
      <IonRow>
        <IonCol>
          <NewInput
            currentLocationOff={isCurrentLocationOff}
            Error={originError}
            labelValue={t('Origin')}
            InputValue={origin}
            InputName={Origin}
            handleChange={(e: any) => props.handleChange(e)}
            isDestination={isDestination}
            deFaultValue={defaultValue}
            locationValue={false}
            useHandler={useHandler}
            setErrorValue={setErrorValue}
            getLocalTime={upDateLocalTime}
            onFocus={props.onFocus || (() => null)}
            country={originCountry}
            postalCode={originPostalCode}
            isCapacitor={isCapacitor}
            allowAnywhere={allowAnywhere}
          />
        </IonCol>
      </IonRow>
      <IonRow>
        <IonCol>
          <RadiusRange
            labelName={t('Origin Radius')}
            rangeDisabled={rangeOriginDisable}
            InputValue={originRadius}
            divClassName="pickRadius"
            name={OriginRadius}
            handleChange={props.handleChange}
          />
        </IonCol>
      </IonRow>
      {props.showDate ? (
        <IonRow>
          <IonCol>
            <PickUpTimeComponent
              pickUpLocalTime={pickUpLocalTime}
              handleChange={dateChanged}
              fromDate={pickUpStartDate}
              toDate={pickUpEndDate}
              error={pickUpdateError}
              handleError={handleError}
              disable={rangeOriginDisable}
              display-timezone="utc"
            />
          </IonCol>
        </IonRow>
      ) : null}
    </IonGrid>
  );
};
export default React.memo(PickupData);
